/*
Model defined for Maintaining Login Requests. It can also be used for transferring model
*/
export class LoginRequestModel {
    email: string;
    password: string;
    constructor(email?: string, password?: string) {
        this.email = email;
        this.password = password;
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/login/LoginRequestModel.ts